import React, { useContext, useEffect, useState } from "react";
import Form from "../../../components/form";
import cfe from "../../../services/cfe";
import AppContext from "../../../container/context";

export default function Inserir(props) {
  const [dados, setDados] = useState({});
  const { notification } = useContext(AppContext);
  const [instituicoes, setInstituicoes] = useState([]);
  const history = props.history;

  useEffect(() => {
    carregarInstituicoes();
  }, []);

  const carregarInstituicoes = () => {
    cfe
      .get("admin/instituicoes/listar")
      .then((res) => {
        setInstituicoes(res);
      })
      .catch((e) => notification("error", "Erro ao listar os instituições"));
  };

  const salvar = (form) => {
    setDados(form);
    cfe
      .put("admin/clientes/inserir", form)
      .then((res) => {
        notification("success", "Cliente inserido com sucesso");
        history.goBack();
      })
      .catch((err) => {
        console.log(err);
        const { data } = err;
        switch (data[0]) {
          case 1:
            return notification("error", "Nome inválido");
          case 2:
            return notification("error", "Email inválido");
          case 3:
            return notification("error", "CPF inválido");
          case 4:
            return notification("error", "Cliente já cadastrado");
          default:
            return notification("error", "Dados inválidos");
        }
      });
  };

  const fDados = {
    title: "Novo cliente",
    form: {
      instituicaoId: {
        label: "Instituição",
        // space: 4,
        value: dados.instituicaoId,
        type: "select",
        emptyItem: true,
        array: {
          data: instituicoes,
          value: "id",
          desc: "nomeFantasia",
        },
        required: true,
      },
      nome: {
        label: "Nome",
        type: "text",
        space: 6,
        value: dados.nome,
        required: true,
      },
      email: {
        type: "text",
        label: "Email",
        space: 4,
        value: dados.email,
        required: true,
      },
      CPF: {
        type: "text",
        label: "CPF (somente números)",
        space: 2,
        value: dados.CPF,
        required: true,
      },
    },

    submit: {
      label: "Salvar",
      action: salvar,
    },

    history,
    close: true,
  };

  return (
    <div>
      <Form formData={fDados} />
    </div>
  );
}
